import React, { PureComponent } from "react";

import { Button, Dropdown, Icon, TileOptionsButton } from "aible";

import Select from "react-select";

import Slider from "rc-slider";

import { Modal } from "react-bootstrap";

import styles from "./style.module.css";

export const colorsTwo = [
  "#D57DF5",
  "#7E69D7",
  "#2F80ED",
  "#56CCF2",
  "#52FFD3",
  "#5BCF74",
  "#96E964",
  "#FFCF71",
  "#F97255",
  "#FF84CE"
];

export default class SubgroupMenu extends React.Component {
  checkIsOverall(dataPoint) {
    return dataPoint && dataPoint.value === "Overall";
  }

  getColor(dataPoint, index, hasOverall) {
    const { drilldownValue } = this.props;
    if (dataPoint.value === drilldownValue) {
      return "#F47C20";
    } else {
      if (hasOverall) {
        if (this.checkIsOverall(dataPoint)) {
          return "transparent";
        } else {
          return colorsTwo[Math.max(0, index - 1) % colorsTwo.length];
        }
      } else {
        return colorsTwo[index % colorsTwo.length];
      }
    }
  }
  getIsNumerical() {
    const { dataset } = this.props;
    return (
      dataset &&
      dataset.outcome &&
      dataset.fields &&
      dataset.fields[dataset.outcome] &&
      dataset.fields[dataset.outcome].type === "number"
    );
  }
  renderMenuItem(mSubgroup, index) {
    const { updateDrilldownValue, show, optimizer, modelGroups, innerId, setupLabels } = this.props;

    const isSelected =
      optimizer && optimizer.drilldownValue && mSubgroup.value && mSubgroup.value === optimizer.drilldownValue;

    const trueAction = setupLabels.trueAction;
    const transactionLabel = setupLabels.transactionLabel;

    const splitColumn =
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.reduce(
        (acc, elem) => (elem && elem.value !== "Overall" ? elem.column : acc),
        undefined
      );

    return (
      <div
        className={
          styles.menuItemWrapper +
          " " +
          (show ? styles.open : styles.isSmall) +
          " " +
          (innerId === mSubgroup.runId ? styles.isActive : "") +
          " " +
          (isSelected ? (show ? styles.mSelectedOpen : styles.mSelectedClosed) : "")
        }
        style={
          !this.checkIsOverall(mSubgroup)
            ? {
                background: mSubgroup.column === "Overall" ? "#7E69D7" : mSubgroup.color,
                color: mSubgroup.color === "#7E69D7" || mSubgroup.column === "Overall" ? "white" : "#4B495B"
              }
            : {
                background: mSubgroup.column === "Overall" ? "#7E69D7" : mSubgroup.color,
                color: mSubgroup.color === "#7E69D7" || mSubgroup.column === "Overall" ? "white" : "#4B495B",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }
        }
        onClick={() => updateDrilldownValue(mSubgroup.runId, mSubgroup.label)}
        key={index}
      >
        {show ? (
          <div
            className={styles.subgroupMenuItem}
            style={this.getIsNumerical() ? { alignItems: "center", height: "100%" } : undefined}
          >
            <div
              className={
                styles.subgroupMenuItemLabel + " " + (innerId === mSubgroup.runId || show ? styles.isActive : "")
              }
            >
              {mSubgroup.label + (mSubgroup.label === "Overall" && splitColumn !== undefined ? ": " + splitColumn : "")}
            </div>
            <div className={styles.subgroupMenuItemDetails}>
              {mSubgroup.label === "Overall" || this.getIsNumerical() ? (
                <div />
              ) : (
                <div className={styles.inputSlider}>
                  <Slider
                    type="range"
                    min={0}
                    max={100}
                    value={mSubgroup.capValue}
                    handleStyle={
                      false
                        ? {
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            borderColor: "rgba(0, 0, 0, 0)"
                          }
                        : {
                            backgroundColor: mSubgroup.color,
                            borderColor: "white",
                            boxShadow: "0px 0px 6px 1px rgba(81, 47, 119, 0.35)"
                          }
                    }
                  />
                </div>
              )}
            </div>
            <div
              className={styles.subgroupMenuItemLabel}
              style={{ marginTop: "6px", fontWeight: "normal" }}
              title={
                mSubgroup.label === "Overall" || this.getIsNumerical()
                  ? undefined
                  : isNaN(mSubgroup.capValue)
                    ? undefined
                    : trueAction + " " + Math.round(mSubgroup.capValue) + "%" + " of " + transactionLabel
              }
            >
              {mSubgroup.label === "Overall" || this.getIsNumerical() ? (
                <div />
              ) : isNaN(mSubgroup.capValue) ? (
                "..."
              ) : (
                trueAction + " " + Math.round(mSubgroup.capValue) + "%" + " of " + transactionLabel
              )}
            </div>
          </div>
        ) : (
          <div className={styles.subgroupMenuItem} style={{ alignItems: "center", height: "100%" }}>
            {mSubgroup && mSubgroup.label ? (
              <div style={{ textTransform: "uppercase" }}>
                {mSubgroup.label === "Overall" ? "ALL" : mSubgroup.label.slice(0, 3)}
              </div>
            ) : (
              <div />
            )}
            <div>
              {mSubgroup.label === "Overall" || this.getIsNumerical() ? (
                <div />
              ) : isNaN(mSubgroup.capValue) ? (
                "..."
              ) : (
                Math.round(mSubgroup.capValue) + "%"
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
  render() {
    const { show, updateShow, modelGroups } = this.props;
    const mSubgroups = modelGroups && modelGroups.drilldownValues;

    return (
      <div
        className={styles.subgroupMenuWrapper + " " + (show ? "" : styles.isSmall)}
        onMouseEnter={() => updateShow(true)}
        onMouseLeave={() => updateShow(false)}
      >
        {mSubgroups && mSubgroups.map((elem, i) => this.renderMenuItem(elem, i))}
        <div className={styles.subgroupMenuFooter} onClick={() => updateShow(!show)}>
          <Icon type={show ? "expandLeft" : "expandRight"} size={14} />
          {show ? <div className={styles.subgroupMenuFooterLabel}>{"Collapse Panel"}</div> : ""}
        </div>
      </div>
    );
  }
}
